import Component from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import MeetingTransparencyMixin from '@/core/mixins/meeting-transparency.mixin';
import { MEETING_EVENTS } from '@/meetings/values/meetings.values';
import { IFRAME_EVENT_TYPES, CLASS_BY_OBJECT_TYPE, RESIZE_TYPES, SCROLL_TYPES_BY_OBJECT, TRANSPARENCY_EVENTS, SECTION_TYPE_CODES, SPLIT_TYPES } from '@/core/values/ed-transparency-meeting.values';
import EdPresentationModeScroll from '@/content/components/ed-presentation-mode/ed-presentation-mode-tools/ed-presentation-mode-scroll';
import EdWhiteboardMenu from '@/core/components/ed-meeting-transparency/ed-whiteboard-menu/ed-whiteboard-menu.component.vue';
import { COURSE_EVENTS } from '@/content/values/events';
import { CLEAR_SELECTED_TOOLBAR_EVENT, ELEMENT_IDS } from '@/content/values/ed-presentation-mode.values';
import { BOARD_EVENTS } from '@/values/ed-whiteboard.values';
import { LOADING_EVENTS } from '@/core/values/core.values';
import { ScreenMirroringMixin } from '@/screen-mirroring/mixins/screen-mirroring.mixin';
import { EdBoardV2 } from '@/components/common/ed-board/ed-board-v2.component.vue';

@Component({
    components: {
        EdWhiteboardMenu,
        EdBoardV2
    }
})
export default class EdStudentMeetingTransparency extends Mixins(ScreenMirroringMixin, MeetingTransparencyMixin) {

    public isLoading : boolean = true;
    private styles = {
        height: '',
        width: '',
        marginLeft: '',
        left: '',
        maxWidth: '',
    };
    private documentContainer = null;
    private isWhiteboardLoading : boolean = true;

    /* Computed */
    get pageSizeInfo() : any {
        return this.$store.state.MeetingsStore.presentationModePageSizeInfo;
    }

    get isStudentToggle() : boolean {
        return this.$store.state.MeetingsStore.currentMeetingData.studentToggle;
    }

    get presentationModeScrollInfo() {
        return this.$store.state.MeetingsStore.presentationModeScrollInfo;
    }

    get presentationModeLayoutInfo() {
        return this.$store.state.MeetingsStore.presentationModeLayoutInfo;
    }

    /* Watchers */
    @Watch('userModeForScreenMirroring')
    reloadScreenMirroring() {
        this.showMenu = true;
        this.addMarginTopToDocument();
    }

    /* Methods */
    private sendMessageIframe() : void {
        this.showMenu = true;
        if(this.$refs.loading){
            this.$refs.loading['hide']();
        }
        this.showWhiteboard();

        this.setReadonly();
        this.scrollWhiteboard();
        this.isWhiteboardLoading = false;
        this.$nextTick(() => this.$edEventBus.$emit(COURSE_EVENTS.CHANGE_PDF_ZOOM, this.zoomObject));
    }

    private resizeWhiteboard() : void {
        this.$edEventBus.$emit(BOARD_EVENTS.RESIZE_BOARD);
        if(this.isWhiteboardLoading || !this.documentContainer){
            return;
        }

        this.$nextTick(() => {
            this.obtainWhitboardSize();
            this.sendMessageIframe();
            this.defineWhiteboardStyles();
        });
    }

    private defineWhiteboardStyles() : void {

        this.$nextTick(() => {
            this.overwriteWhiteboardStyles();
        });
    }

    private overwriteWhiteboardStyles() : void {
        setTimeout(() => {
            let height : number = this.documentContainer.offsetHeight;
            let width : number = this.documentContainer.offsetWidth;
            let left : number = null;

            if(!this.zoomObject){
                this.obtainElementContainer();
                width = this.elementContainer.offsetWidth;
                let componentElement : HTMLElement = document.getElementById(ELEMENT_IDS.COMPONENT);
                let componentElementRect : DOMRect = componentElement.getBoundingClientRect();
                let elementContainerRect : DOMRect = this.elementContainer.getBoundingClientRect();

                left = elementContainerRect.left - componentElementRect.left;
            }

            this.styles = {
                height: `${height}px`,
                width: `${width}px`,
                maxWidth: `${width}px`,
                marginLeft: '',
                left: ''
            };

            if(left){
                this.styles.marginLeft = `${left}px`;
                this.styles.left = '0';
            }

        }, 100);
    }

    private scrollWhiteboard() {
        if(!SCROLL_TYPES_BY_OBJECT[this.presentationModeViewerType]){
            return;
        }
        let objectType : string = SCROLL_TYPES_BY_OBJECT[this.presentationModeViewerType];
        let elementScrollTop = EdPresentationModeScroll.obtainScrolltop(objectType, this.documentIndex);
        let sectionContainer = document.querySelector(`.ed-student-meeting-transparency > #page-container-${this.whiteboardPath}`);
        sectionContainer?.scrollTo(0, elementScrollTop);
    }

    private showWhiteboard() : void {
        this.obtainWhitboardSize();
        this.defineWhiteboardStyles();
        this.isWhiteboardLoading = false;
    }

    private obtainWhitboardSize() : void {
        this.obtainElementContainer();
        this.addMarginTopToDocument();
        let containerWidth  : number = this.documentContainer.offsetWidth;
        let documentHeight  : number = this.documentContainer.scrollHeight - this.translateTopDefault;
        let widthElement    : number = containerWidth;

        if(!RESIZE_TYPES.includes(this.presentationModeViewerType)){
            widthElement = this.elementContainer.offsetWidth;

        }

        if(RESIZE_TYPES.includes(this.presentationModeViewerType)){
            documentHeight = this.elementContainer.scrollHeight;
        }

        this.whiteboardInfo = {
            width: widthElement,
            height: documentHeight,
            zoom: this.zoomObject
        };
    }

    private addMarginTopToDocument(){
        if(this.showMenu) {
            this.elementContainer.style.setProperty('transform', `translateY(${this.translateTopDefault}px)`);
        } else {
            this.elementContainer.style.removeProperty('transform');
        }
    }

    private setReadonly() : void {
        if(this.isStudentToggle){
            this.$edEventBus.$emit(CLEAR_SELECTED_TOOLBAR_EVENT);
        }
    }

    private changeDocumentZoom(page?) : void {
        this.$edEventBus.$emit(`${BOARD_EVENTS.RESIZE_BOARD}-${page}`, true);
        this.overwriteWhiteboardStyles();
        this.$edEventBus.$emit(COURSE_EVENTS.CHANGE_PDF_ZOOM, this.zoomObject);
    }

    public setDocumentContainerHeight() {
        const container = this.documentContainer ?? document.getElementsByClassName(CLASS_BY_OBJECT_TYPE[this.presentationModeViewerType])[this.documentIndex];
        this.styles = { ...this.styles,  height: `${container.offsetHeight}px` };
    }

    private finishLoading(): void {
        this.isLoading = false;
        this.$edEventBus.$emit(BOARD_EVENTS.STUDENT_INITIAL_BOARDS_LOADED, this.presentationModeScrollInfo, true);
        this.$edEventBus.$emit(BOARD_EVENTS.UPDATE_LAYOUT, this.presentationModeLayoutInfo, true);
    }

    /* Hooks */
    private obtainContainer(): void {
        const className: string = CLASS_BY_OBJECT_TYPE[this.presentationModeViewerType];
        const index: number = SPLIT_TYPES.includes(this.presentationModeViewerType) && this.areMultiplePresentationModeViewerTypes ?
            0 : this.documentIndex;
        this.documentContainer = document.getElementsByClassName(className)[index];
    }

    async mounted() {
        //this.$refs.loading['show'](this.$i18n.t('common.loadingPresentationMode'));
        this.$edEventBus.$on(BOARD_EVENTS.CLOSE_LOADING_BOARD_TASK, this.closeLoading);
        this.$edEventBus.$on(BOARD_EVENTS.BOARD_READY, this.closeLoading);
        this.$edEventBus.$on(BOARD_EVENTS.INIT_BOARD_TASK, this.initBoard)
        this.connect();
        this.$edEventBus.$emit(LOADING_EVENTS.SHOW, this.$i18n.t('common.loadingPresentationMode'));
        await this.loadWhiteboardPath();
        this.finishLoading();
        this.obtainContainer();

        this.$edEventBus.$on(MEETING_EVENTS.RESIZE_WHITEBOARD_TRANSPARENCY, this.resizeWhiteboard);
        this.$edEventBus.$on(MEETING_EVENTS.SCROLL_WHITEBOARD_TRANSPARENCY, this.scrollWhiteboard);
        this.$edEventBus.$on(MEETING_EVENTS.SET_READ_ONLY_STUDENT, this.setReadonly);
        this.$edEventBus.$on(TRANSPARENCY_EVENTS.CHANGE_DOCUMENT_ZOOM, this.changeDocumentZoom);
        await this.showWhiteboard();
        this.resizeWhiteboard();
        window.addEventListener('resize', this.resizeWhiteboard);
    }

    beforeDestroy() {
        this.disconnectSocket();
        this.$edEventBus.$off(MEETING_EVENTS.RESIZE_WHITEBOARD_TRANSPARENCY, this.resizeWhiteboard);
        this.$edEventBus.$off(MEETING_EVENTS.SCROLL_WHITEBOARD_TRANSPARENCY, this.scrollWhiteboard);
        this.$edEventBus.$off(MEETING_EVENTS.SET_READ_ONLY_STUDENT, this.setReadonly);
        this.$edEventBus.$off(TRANSPARENCY_EVENTS.CHANGE_DOCUMENT_ZOOM, this.changeDocumentZoom);
        if(this.elementContainer){
            this.elementContainer.style.removeProperty('transform');
        }
        this.$edEventBus.$off(BOARD_EVENTS.CLOSE_LOADING_BOARD_TASK, this.closeLoading);
        this.$edEventBus.$off(BOARD_EVENTS.BOARD_READY, this.closeLoading);
        this.$edEventBus.$off(BOARD_EVENTS.INIT_BOARD_TASK, this.initBoard)
        window.removeEventListener('resize', this.resizeWhiteboard);
    }
}
